import React, { useCallback, useEffect } from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell, LinearProgress } from '@material-ui/core'

const COLUMNS = [
  "#",
  "Телефон",
  "Дата купівлі",
  "Маршрут",
  "Дата відправлення",
  "Звідки",
  "Куди",
  "Добавив(-ла)",
  "Ціна",
  "Відмітка"
]

const renderTableHeadCell = label => (
  <TableCell padding='dense' key={label}>
    {label}
  </TableCell>
)

const renderBooking = ({
  id, routeName, createdDate, departureDate, from, to, price, phone, userName, userRole, note
}, index) => (
  <TableRow key={id}>
    <TableCell padding='dense'>
      {index + 1}
    </TableCell>

    <TableCell padding='dense'>
      {phone}
    </TableCell>

    <TableCell padding='dense'>
      {createdDate.split(' ')[0]}
    </TableCell>

    <TableCell padding='dense'>
      {routeName}
    </TableCell>

    <TableCell padding='dense'>
      {departureDate}
    </TableCell>

    <TableCell padding='dense'>
      {from}
    </TableCell>

    <TableCell padding='dense'>
      {to}
    </TableCell>

    <TableCell padding='dense'>
      {userName} ({userRole})
    </TableCell>

    <TableCell padding='dense'>
      {price}
    </TableCell>

    <TableCell padding='dense'>
      {note}
    </TableCell>
  </TableRow>
)

export const BlacklistPassengerBookings = (props) => {
  const { data: { passenger } } = props

  useEffect(() => {
    props.getBlacklistPassengerBookings(passenger)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Table>
      <TableHead>
        <TableRow>
          {COLUMNS.map(renderTableHeadCell)}
        </TableRow>
      </TableHead>
      <TableBody>
        {props.isLoadingBlacklistModal && (
          <TableRow>
            <TableCell colSpan='7'>
              <LinearProgress />
            </TableCell>
          </TableRow>
        )}
        {props.blacklistPassengerBookings.map(renderBooking)}
      </TableBody>
    </Table>
  );
};

BlacklistPassengerBookings.defaultProps = {
  isLoadingBlacklistModal: true
}


// WEBPACK FOOTER //
// ./src/components/BlacklistPassengerBookings/BlacklistPassengerBookings.js